import Analytics from '@opencare/analytics';
import loDebounce from 'lodash/debounce';
import moment from 'moment';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { UpdatePatientSilently } from 'connect/saga/handlers/update-patient-silently/update-patient-silently';
import { selectDataPatient } from 'connect/selectors';

const analytics = new Analytics();

const RouteListener = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const patient = useSelector(selectDataPatient);

  const tryUpdatePatient = useCallback(() => loDebounce(
    () => {
      if (!patient?.id) {
        return;
      }

      dispatch(
        UpdatePatientSilently.createAction({
          patientId: patient.id,
          lastSeenAt: moment.utc().toISOString(),
        }),
      );
    },
    // 5 seconds debounce (do not update more than once every 5 seconds).
    5000,
    {
      // Fire on the leading edge only
      leading: true,
      trailing: false,
    },
  ), [patient?.id, dispatch]);

  useEffect(() => {
    analytics.trackDefaultPageView();

    const unlisten = history.listen(() => {
      analytics.trackDefaultPageView();
      tryUpdatePatient();
    });

    return () => unlisten();
  }, [history, tryUpdatePatient]);

  return props.children;
};

export default RouteListener;
